"use client";

import { useCallback, useMemo } from "react";
import { parseAsString } from "nuqs";
import { ArbiAcademyModal } from "@/components/ui/arbi-academy-modal";
import { useQuerySearchParams } from "@/hooks/use-query-search-params";
import { TASKS_ACADEMY_CONTENT } from "../lib/tasks";

const TASKS_ACADEMY_QUERY = {
  field: "tasks_academy",
  parser: parseAsString.withDefault(""),
} as const;

export function useOpenTasksAcademy() {
  const [, setParam] = useQuerySearchParams(TASKS_ACADEMY_QUERY);
  return useCallback(() => {
    setParam("true", { history: "replace", scroll: false });
  }, [setParam]);
}

export function TasksAcademyModal() {
  const [raw, setParam] = useQuerySearchParams(TASKS_ACADEMY_QUERY);
  const open = useMemo(() => raw === "true", [raw]);

  const onClose = useCallback(() => {
    setParam(null, { history: "replace", scroll: false });
  }, [setParam]);

  return (
    <ArbiAcademyModal
      open={open}
      onClose={onClose}
      content={TASKS_ACADEMY_CONTENT}
    />
  );
}
